import { render, staticRenderFns } from "./DonutChart60.vue?vue&type=template&id=82928038&scoped=true"
import script from "./DonutChart60.vue?vue&type=script&lang=js"
export * from "./DonutChart60.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82928038",
  null
  
)

export default component.exports